import { render, staticRenderFns } from "./VocabularyWordsPreview.vue?vue&type=template&id=0424fade&lang=pug&"
import script from "./VocabularyWordsPreview.vue?vue&type=script&lang=js&"
export * from "./VocabularyWordsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports